<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog">
    <div class="modal-content" style="width: 550px;margin-left: 5%;    border-radius: 7px;">
      <div class="modal-header"
        style="color:white;line-height: 0.5;border-bottom: 1px solid var(--brand-primary-color);background: var(--brand-primary-color);border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
        <div class="modal-title" style="font-weight: 500">
          <span style="margin-left: 10px;">{{ 'deactivatingStudent' | translate }} <b>{{studentName ?
              studentName.toUpperCase():''}}</b></span>
        </div>
      </div>
      <div class="modal-body">
        <!-- bus info -->
        <div class="row">
          <div class="form-group" style="padding: 20px">
            <select [(ngModel)]="selectedReason" id="edit-student-deactive-reason-select"
              name="edit-student-deactive-reason-select" class="form-control" style="border: 1px solid #e2e2e2;">
              <option [value]="null">{{ 'noneSelected' | translate }}</option>
              <hr />
              <optgroup *ngFor="let r of deactivateReasons" [label]="r.description">
                <option [value]="r.pkDeactivateReasonId">
                  {{r.reason}} {{ r.deactivateWithCollectedFee === 'YES' ? '(Deactivate with
                  collected fees)' : '(Deactivate without affecting collected fees)' }}
                </option>
                <hr />
              </optgroup>
            </select>
            <label style="left: unset;" for="edit-student-deactive-reason-select"
              class="deactivate-student-label">{{ 'selectReason' | translate }}&nbsp;<i *ngIf="isDataLoading"
                class="fa fa-spinner fa-spin"></i></label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="isDeactivateProcessing || isDataLoading" style="background: var(--brand-primary-color);color: white"
          type="button" class="btn btn-raised btn-lg btn-block" data-dismiss="modal" (click)="popupOkAction()"><i
            *ngIf="isDeactivateProcessing" class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;{{ 'deactivate' | translate }}</button>
      </div>
    </div>
  </div>
</div>